export default "__VITE_ASSET__790087af__"